import { handleMenuItemClick } from 'components/views/PublicRoom/_helpers/publicRoom.events';
import { $alert, $user, $form, $view } from 'signals/global.signals';
import { createRoomView } from 'api/rooms.api';

export const handleEmailChange = (e) => {
  $form.value.email = e.target.value;
};

const setLocalStorageSubmittedEmail = (email) => {
  window.localStorage.setItem('submittedEmail', email);
};

export const handleSubmitEmail = async (id) => {
  console.log('handleSubmitEmail', id, $form.value.email);
  $view.update({ isEmailFormVisible: false, isConfettiVisible: true, isMenuVisible: false, isQuickAccessVisible: false });
  setLocalStorageSubmittedEmail($form.value.email || $user.value.email);
  try {
    await createRoomView(id, {
      email: $form.value.email,
    });
    handleMenuItemClick({ tab: 'company-snapshot', isShowFadeIn: true });
  } catch (error) {
    $alert.update({
      message: error.message,
      variant: 'danger',
    });
  } finally {
    $view.update({ isEmailFormVisible: false, isConfettiVisible: false, isMenuVisible: true });
  }
};

export const handleConfettiComplete = () => {
  $view.update({ isConfettiVisible: false, isEmailFormVisible: false, isMenuVisible: true });
};
